var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.themes),function(theme){return _c('div',{key:theme.name},[_c('Sample',_vm._b({on:{"set-theme":function($event){return _vm.setTheme($event)}}},'Sample',theme,false))],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }